import { isType, prop, type PropsElement } from '../props';
import { normalizeType } from './vocabulary';

export function ofType(elements: PropsElement[], type: unknown): PropsElement[] {
  const t = normalizeType(type);
  if (!t) return elements;
  return elements.filter((e) => isType(e, t));
}

export function inStorey(elements: PropsElement[], storey: unknown): PropsElement[] {
  const s = String(storey ?? '')
    .trim()
    .toLowerCase();
  if (!s) return elements;
  return elements.filter((e) => (e.storey ?? '').toLowerCase().includes(s));
}

export function readProp(e: PropsElement, pset: unknown, name: unknown): string | null {
  return prop(e, String(pset), String(name));
}

export function countBy<T>(items: T[], key: (item: T) => string): Record<string, number> {
  const out: Record<string, number> = {};
  for (const it of items) out[key(it)] = (out[key(it)] ?? 0) + 1;
  return out;
}

export const storeyKey = (e: PropsElement) => e.storey ?? '–';

export const round = (v: number, digits = 2) => Number(v.toFixed(digits));
